module.exports = __webpack_public_path__ + "static/media/Jesus.2495d683.png";